import { LoadingOutlined } from '@ant-design/icons'
import * as Styles from './styles'

interface propsLoading {
  loading: boolean
}

function GenericLoading({ loading }: propsLoading) {
  return (
    <span>
      {loading && (
        <Styles.Overlay>
          <Styles.Container>
            <LoadingOutlined spin />
          </Styles.Container>
        </Styles.Overlay>
      )}
    </span>
  )
}

export default GenericLoading
